import { useState } from "react"
import { observer } from "mobx-react-lite"

import { PercentageButtonsPercentIcon } from "@/domains/icons/huge-icons/monotone/percentage-buttons-percent"
import { PercentageButtonsSliderIcon } from "@/domains/icons/huge-icons/monotone/percentage-buttons-slider"

import { TokenInputDisabled } from "./token-input-card"
import { ITokenPercentageButtons, TokenPercentageButtons } from "./token-percentage-buttons"
import { TokenPercentageSlider } from "./token-percentage-slider"

export interface ITokenToggle {
  balance: bigint
  formatUnits: (balance: bigint) => string
}
/**
 *
 * @param sliderValue must be external state so other components can also reset/alter it,
 *                    This will allow one percentage slider change to update the other
 * @returns
 */
export const TokenToggleButtonsSlider = observer(
  ({
    token,
    buttonsToken,
    disabled,
    sliderValue,
    onSetSliderValue,
    onTokenAmountChange,
  }: {
    token: ITokenToggle
    buttonsToken: ITokenPercentageButtons
    disabled: TokenInputDisabled
    sliderValue: number
    onSetSliderValue: (value: number) => void
    onTokenAmountChange: (newAmount: string) => void
  }) => {
    const [togglePercentageButtons, setTogglePercentageButtons] = useState(true)

    if (togglePercentageButtons) {
      return (
        <div className="flex flex-row items-center justify-between">
          <TokenPercentageButtons
            disabled={disabled.percentageButtons}
            token={buttonsToken}
            onClick={(newAmount) => {
              onTokenAmountChange(newAmount)
              // Calculate the percentage based on the new amount and update slider value
              const percentage =
                token.balance > 0 ? (Number(newAmount) / Number(token.formatUnits(token.balance))) * 100 : 0
              onSetSliderValue(Math.min(100, Math.max(0, percentage)))
            }}
          />
          <PercentageButtonsSliderIcon size={24} onClick={() => setTogglePercentageButtons(!togglePercentageButtons)} />
        </div>
      )
    }

    return (
      <div className="flex h-[32px] min-h-[32px] flex-row items-center justify-between">
        <TokenPercentageSlider
          disabled={disabled.percentageButtons}
          token={buttonsToken}
          onChange={(newAmount) => {
            onTokenAmountChange(newAmount)
            // Calculate the percentage based on the new amount
            const percentage =
              token.balance > 0 ? (Number(newAmount) / Number(token.formatUnits(token.balance))) * 100 : 0
            onSetSliderValue(Math.min(100, Math.max(0, percentage)))
          }}
          value={sliderValue}
        />
        <PercentageButtonsPercentIcon size={24} onClick={() => setTogglePercentageButtons(!togglePercentageButtons)} />
      </div>
    )
  },
)
